/**
 * src/components/ui/Button.jsx
 * Botón base con variantes y estados.
 */

const VARIANTS = {
  primary: {
    background: 'var(--color-accent)',
    color: '#fff',
    border: '1px solid transparent',
    hover: 'var(--color-accent-2)',
  },
  secondary: {
    background: 'var(--color-surface-2)',
    color: 'var(--color-text)',
    border: '1px solid var(--color-border)',
    hover: 'var(--color-border)',
  },
  danger: {
    background: 'rgba(239,68,68,0.12)',
    color: 'var(--color-error)',
    border: '1px solid rgba(239,68,68,0.25)',
    hover: 'rgba(239,68,68,0.2)',
  },
  ghost: {
    background: 'transparent',
    color: 'var(--color-text-2)',
    border: '1px solid transparent',
    hover: 'var(--color-surface-2)',
  },
}

const SIZES = {
  sm: { padding: '5px 12px', fontSize: '12px', borderRadius: '6px' },
  md: { padding: '8px 16px', fontSize: '13px', borderRadius: '8px' },
  lg: { padding: '11px 22px', fontSize: '14px', borderRadius: '8px' },
}

export function Button({
  children,
  variant = 'primary',
  size = 'md',
  disabled = false,
  loading = false,
  icon = null,
  fullWidth = false,
  onClick,
  type = 'button',
  style: extraStyle = {},
}) {
  const v = VARIANTS[variant] || VARIANTS.primary
  const s = SIZES[size] || SIZES.md
  const isDisabled = disabled || loading

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={isDisabled}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '7px',
        background: v.background,
        color: v.color,
        border: v.border,
        borderRadius: s.borderRadius,
        padding: s.padding,
        fontSize: s.fontSize,
        fontWeight: 500,
        fontFamily: 'var(--font-ui)',
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        opacity: isDisabled ? 0.55 : 1,
        transition: 'all 0.15s',
        width: fullWidth ? '100%' : 'auto',
        whiteSpace: 'nowrap',
        letterSpacing: '0.01em',
        ...extraStyle,
      }}
      onMouseEnter={e => {
        if (!isDisabled) e.currentTarget.style.background = v.hover
      }}
      onMouseLeave={e => {
        if (!isDisabled) e.currentTarget.style.background = v.background
      }}
    >
      {loading ? (
        <span style={{
          width: '13px', height: '13px',
          border: '2px solid currentColor',
          borderTopColor: 'transparent',
          borderRadius: '50%',
          display: 'inline-block',
          animation: 'spin 0.7s linear infinite',
        }} />
      ) : icon}
      {children}
    </button>
  )
}
